// Third-party
import React, { ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
  className?: string;
  children?: ReactNode;
}

const Pastille = ({ children, className, ...rest }: Props) => (
  <div className={classNames('pastille', className)} {...rest}>
    {children}
  </div>
);

export default Pastille;
